<template>
  <v-container>
    <v-row class="justify-center">
      <!-- <exchange :Etype="ExchageType" :showBalance="ShowTotalCash"></exchange> -->

      <v-col cols="12" class="d-flex d-md-none">
        <cashDisplay :isloading="loading" :Balance="MaitnCash"></cashDisplay>
      </v-col>
      <v-col cols="12" class="d-flex d-md-none justify-center">
        <exchange :Etype="ExchageType" :showBalance="ShowTotalCash"></exchange>
      </v-col>
      <v-col cols="12" class="d-none d-md-flex">
        <v-toolbar color="grey lighten-2">
          <v-toolbar-items>
            <exchange
              :Etype="ExchageType"
              :showBalance="ShowTotalCash"
            ></exchange>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <cashDisplay
              :isloading="loading"
              :Balance="MaitnCash"
            ></cashDisplay>
          </v-toolbar-items>
        </v-toolbar>
      </v-col>
      <!-- <v-col></v-col> -->
      <v-col lg="4" md="4" cols="10">
        <v-container grid-list-md>
          <v-card color="grey lighten-2" hover>
            <Barchart
              :options="ChrtOpj.optionSellBuy"
              :chartData="datacollectionSellBuy"
            ></Barchart>
          </v-card>
        </v-container>
      </v-col>
      <v-col lg="8" md="8" cols="10">
        <v-row>
          <v-col lg="6" md="6" cols="12">
            <v-container grid-list-md>
              <v-card color="grey lighten-2" hover>
                <Barchart
                  :options="ChrtOpj.option"
                  :chartData="datacollection"
                ></Barchart>
              </v-card>
            </v-container>
          </v-col>
          <v-col lg="6" md="6" cols="12">
            <v-container grid-list-md>
              <v-card color="grey lighten-2" hover>
                <PieChart :options="option2" :chartData="ProfitData"></PieChart>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col lg="6" cols="12">
        <v-container grid-list-md>
          <v-card color="grey lighten-2" hover>
            <Barchart
              :options="USDoptions"
              :chartData="datacollectionUSD"
            ></Barchart>
          </v-card>
        </v-container>
      </v-col>
      <v-col lg="6" cols="12">
        <v-container grid-list-md>
          <profitLossCMP
            :isLoading="loadingProfit"
            :sellRate="weekProfitLoss.SellRate"
            :BuyRate="weekProfitLoss.BuyRete"
            :TotalSell="weekProfitLoss.totalSell"
            :TotalBuy="weekProfitLoss.totalBuy"
            :profitLoss="weekProfitLoss.Profit"
          ></profitLossCMP>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import { allReq } from "@/axiosfiles/axios-outh";
import axios from "axios";
import PieChart from "@/components/PieChart.vue";
import exchange from "@/components/Exchange.vue";
import cashDisplay from "@/components/displayCash.vue";
import Barchart from "@/components/waeklychart.vue";
import profitLossCMP from "@/components/w_ProfitLoss.vue";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  components: { exchange, cashDisplay, Barchart, PieChart, profitLossCMP },
  data() {
    return {
      dialog: false,
      ExchageType: "test",
      weekProfitLoss: {},
      AllSellBuy: [],
      ProfitData: {},
      MaitnCash: [],
      USDExchange: [],
      loading: true,
      loadingProfit: true,
      datacollection: {},
      datacollectionUSD: {},
      datacollectionSellBuy: {},

      USDoptions: {
        maintainAspectRatio: false,
        title: { text: `7 day USD Buy and Sell Report`, display: true },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return `${
                data.datasets[tooltipItem.datasetIndex].label
              }: ${tooltipItem.yLabel.toLocaleString()} $`;
            },
          },
        },
      },
      option2: {
        maintainAspectRatio: false,
        title: {
          text: `Daily USD Profit Or Loss`,
          display: true,
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              // console.log(tooltipItem[0].index);
              // console.log(data);
              return data.labels[tooltipItem[0].index];
            },
            label: function(tooltipItem, data) {
              // console.log(tooltipItem);
              return data.datasets[tooltipItem.datasetIndex].data[
                tooltipItem.index
              ].toLocaleString();
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["LocalCurrencyGetter"]),
    BaseCash() {
      if (this.LocalCurrencyGetter.length)
        return this.LocalCurrencyGetter[0].Cashcode;
      return "KES";
    },
    ChrtOpj() {
      return {
        optionSellBuy: {
          maintainAspectRatio: false,
          title: {
            text: `7 day All Buy and Sell in ${this.BaseCash}`,
            display: true,
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return `${
                  data.datasets[tooltipItem.datasetIndex].label
                }: ${tooltipItem.yLabel.toLocaleString()} ${this.BaseCash}`;
              },
            },
          },
        },
        option: {
          maintainAspectRatio: false,
          title: {
            text: `7 day USD Buy and Sell in ${this.BaseCash}`,
            display: true,
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return `${
                  data.datasets[tooltipItem.datasetIndex].label
                }: ${tooltipItem.yLabel.toLocaleString()} ${this.BaseCash}`;
              },
            },
          },
        },
      };
    },
  },
  watch: {
    dialog(val) {
      // console.log(val);
      if (val == false) {
        this.ExchageType = "";
      }
    },
  },
  methods: {
    ShowTotalCash(Account) {
      this.dialog = false;
      this.MaitnCash = [];
      this.weekly = [];
      this.loading = true;
      this.$store
        .dispatch("INSERT_ONLY", {
          url: `/qarash/totalcash`,
          data: { Account },
        })
        .then(response => {
          // console.log(response);
          this.loading = false;
          this.MaitnCash = response.data;

          var thisweek = new Date();
          thisweek.setDate(thisweek.getDate() - 6);
          this.CompountRequest(this.Current(thisweek).date);
        });
    },
    fillData() {
      let dataSet = this.extract();
      this.datacollection = {
        labels: _.uniq(dataSet.label),
        datasets: [
          {
            label: "Sell",
            // backgroundColor: "#A5D6A7",
            backgroundColor: "teal",
            data: dataSet.sellData,
            borderWidth: 1,
            borderColor: "red",
            hoverBorderWidth: 3,
            hoverBorderColor: "black",
          },
          {
            label: "Buy",
            backgroundColor: "lime ",
            data: dataSet.buyData,
            borderWidth: 1,
            borderColor: "red",
            hoverBorderWidth: 3,
            hoverBorderColor: "black",
          },
        ],
      };
    },
    fillUSD() {
      let dataSet = this.extractUSD();
      this.datacollectionUSD = {
        labels: _.uniq(dataSet.label),
        datasets: [
          {
            label: "Sell",
            // backgroundColor: "#A5D6A7",
            backgroundColor: "Red",
            data: dataSet.sellData,
            borderWidth: 1,
            borderColor: "red",
            hoverBorderWidth: 3,
            hoverBackgroundColor: "#EF9A9A",
          },
          {
            label: "Buy",
            backgroundColor: "Blue",
            data: dataSet.buyData,
            borderWidth: 1,
            borderColor: "blue",
            hoverBorderWidth: 3,
            hoverBackgroundColor: "#90CAF9",
          },
        ],
      };
    },
    fillAllSellBuy() {
      let dataSet = this.extractAllSellBuy();
      this.datacollectionSellBuy = {
        labels: _.uniq(dataSet.label),
        datasets: [
          {
            label: "Sell",
            // backgroundColor: "#A5D6A7",
            backgroundColor: "orange",
            data: dataSet.sellData,
            borderWidth: 1,
            borderColor: "red",
            hoverBorderWidth: 3,
            hoverBackgroundColor: "#EF9A9A",
          },
          {
            label: "Buy",
            backgroundColor: "blue-grey",
            data: dataSet.buyData,
            borderWidth: 1,
            borderColor: "blue",
            hoverBorderWidth: 3,
            hoverBackgroundColor: "#90CAF9",
          },
        ],
      };
    },
    fillPieChart() {
      // this.option2.title.text = `Daily Profit Or Loss`;
      let dataSetPi = this.ProitLoss();
      // console.log(dataSetPi.ProfitLossData);
      this.ProfitData = {
        labels: dataSetPi.ProfitLossLabel,
        datasets: [
          {
            backgroundColor: [
              "rgba(61, 72, 196)",
              "red",
              "rgba(86, 186, 112)",
              "rgba(189, 135, 102)",
              "rgba(143, 52, 153)",
              "rgba(61, 115, 0)",
              "rgba(255, 191, 0)",
            ],
            data: dataSetPi.ProfitLossData,
            borderWidth: 1,
            borderColor: "red",
            hoverBorderWidth: 3,
            hoverBorderColor: "black",
          },
        ],
      };
    },
    extract() {
      let label = [];
      let buyData = [];
      let sellData = [];

      let n = 0;
      // console.log(this.weekly);

      while (n < this.weekly.length - 1) {
        if (this.weekly[n].date === this.weekly[n + 1].date) n += 2;
        else {
          let index = n;
          // let uniq = Object.assign({}, this.weekly[n]);
          let uniq = this.jsonCopy(this.weekly[n]);
          uniq.Description = uniq.Description === "Sell" ? "Buy" : "Sell";
          uniq.Amount = 0;
          this.weekly.splice(index, 0, uniq);
          n += 2;
        }
      }

      for (let index = 0; index < this.weekly.length; index++) {
        label.push(this.weekly[index].date);
        if (this.weekly[index].Description === "Buy")
          buyData.push(Math.abs(this.weekly[index].Amount));
        else if (this.weekly[index].Description === "Sell")
          sellData.push(this.weekly[index].Amount);
      }
      return { label, sellData, buyData };
    },
    extractUSD() {
      let label = [];
      let buyData = [];
      let sellData = [];
      // let sellRate = [];
      // let buyRate = [];

      for (let index = 0; index < this.USDExchange.length; index++) {
        label.push(this.USDExchange[index].date);
        if (this.USDExchange[index].ExchangeType === "Buy") {
          buyData.push(this.USDExchange[index].Amount);
          // if (this.USDExchange[index].avgRate !== 0)
          //   buyRate.push(this.USDExchange[index].avgRate);
        } else if (this.USDExchange[index].ExchangeType === "Sell") {
          sellData.push(this.USDExchange[index].Amount);
          // if (this.USDExchange[index].avgRate !== 0)
          //   sellRate.push(this.USDExchange[index].avgRate);
        }
      }
      // console.log(sellData);
      return { label, sellData, buyData };
    },
    extractAllSellBuy() {
      let label = [];
      let buyData = [];
      let sellData = [];

      this.AdjestAllSellBuy();

      for (let index = 0; index < this.AllSellBuy.length; index++) {
        label.push(this.AllSellBuy[index].date);
        if (this.AllSellBuy[index].Description === "Buy")
          buyData.push(Math.abs(this.AllSellBuy[index].Amount));
        else if (this.AllSellBuy[index].Description === "Sell")
          sellData.push(this.AllSellBuy[index].Amount);
      }
      // console.log(this.AllSellBuy);
      // console.log(sellData);
      return { label, sellData, buyData };
    },
    AdjestAllSellBuy() {
      let n = 0;

      while (n < this.AllSellBuy.length - 1) {
        if (this.AllSellBuy[n].date === this.AllSellBuy[n + 1].date) n += 2;
        else {
          let index = n;
          // let uniq = Object.assign({}, this.AllSellBuy[n]);
          let uniq = this.jsonCopy(this.AllSellBuy[n]);
          uniq.Description = uniq.Description === "Sell" ? "Buy" : "Sell";
          uniq.Amount = 0;
          // uniq.avgRate = 0;
          this.AllSellBuy.splice(index, 0, uniq);
          n += 2;
        }
      }
    },
    AdjestUSD() {
      let n = 0;

      while (n < this.USDExchange.length - 1) {
        if (this.USDExchange[n].date === this.USDExchange[n + 1].date) n += 2;
        else {
          let index = n;
          // let uniq = Object.assign({}, this.USDExchange[n]);
          let uniq = this.jsonCopy(this.USDExchange[n]);
          uniq.ExchangeType = uniq.ExchangeType === "Sell" ? "Buy" : "Sell";
          uniq.Amount = 0;
          // uniq.avgRate = 0;
          this.USDExchange.splice(index, 0, uniq);
          n += 2;
        }
      }
    },
    ProfitCalaculate() {
      // let USD_info = this.extractUSD();
      // let KES_info = this.extract();

      let USD_info =
        this.BaseCash == "USD" ? this.extract() : this.extractUSD();
      let KES_info =
        this.BaseCash == "USD" ? this.extractUSD() : this.extract();

      let totalSell = _.sum(USD_info.sellData);
      let totalBuy = _.sum(USD_info.buyData);
      let SellRate = _.sum(KES_info.sellData) / totalSell;
      let BuyRete = _.sum(KES_info.buyData) / totalBuy;
      let Deff_Rete = SellRate - BuyRete;
      let Profit;
      // console.log(Deff_Rete);
      if (totalSell <= totalBuy) {
        Profit = totalSell * Deff_Rete;
      } else if (totalSell > totalBuy) Profit = totalBuy * Deff_Rete;
      this.loadingProfit = false;
      if (this.BaseCash == "USD") Profit = Profit * -1;
      return { Profit, SellRate, BuyRete, totalSell, totalBuy };
    },
    ProitLoss() {
      let USD_info =
        this.BaseCash == "USD" ? this.extract() : this.extractUSD();
      let KES_info =
        this.BaseCash == "USD" ? this.extractUSD() : this.extract();
      let ProfitLossData = [];
      let ProfitLossLabel = _.uniq(USD_info.label);

      // console.log(KES_info);

      for (let index = 0; index < USD_info.sellData.length; index++) {
        let SellRate = KES_info.sellData[index] / USD_info.sellData[index];
        let PuyRate = KES_info.buyData[index] / USD_info.buyData[index];
        let DeffRate = SellRate - PuyRate;

        // console.log(SellRate);
        // console.log(KES_info.buyData[index], "buy rate");

        if (USD_info.sellData[index] <= USD_info.buyData[index]) {
          //Calculating Rate Deffrence of sell and buy
          // let DeffRate =
          //   KES_info.sellData[index] / USD_info.sellData[index] -
          //   KES_info.buyData[index] / USD_info.buyData[index];

          // console.log(Math.round(DeffRate * 100));

          //Pushing Profit and loss
          ProfitLossData.push(DeffRate * USD_info.sellData[index]);
        } else if (USD_info.sellData[index] > USD_info.buyData[index]) {
          // let DeffRate =
          //   KES_info.sellData[index] / USD_info.sellData[index] -
          //   KES_info.buyData[index] / USD_info.buyData[index];

          //Pushing Profit and loss
          let myProfit = DeffRate * USD_info.buyData[index];
          // console.log(myProfit);

          ProfitLossData.push(myProfit);
        }
        let profit = Math.round(ProfitLossData.pop());
        if (this.BaseCash == "USD") profit = profit * -1;
        ProfitLossData.push(profit);

        // console.log();
      }
      return { ProfitLossData, ProfitLossLabel };
    },
    weeklyReport(url, from, Details = undefined) {
      return this.$store.dispatch("UPDATE_DATA_Only", {
        url: `/exchange/${url}`,
        data: { from, local: this.LocalCurrencyGetter[0].Cashcode, Details },
      });
    },
    CompountRequest(from) {
      this.weekProfitLoss = {};
      this.loadingProfit = true;
      let ExDetails = `KES-USD`;
      if (this.LocalCurrencyGetter[0].Cashcode === "USD") ExDetails = "USD-KES";
      // console.log(ExDetails);
      axios
        .all([
          this.weeklyReport("sellorbuy", from, ExDetails),
          this.weeklyReport("sellorbuy", from),
          this.weeklyReport("OtherAmount", from),
        ])
        .then(response => {
          // console.log(response);
          this.weekly = response[0].data;
          this.AllSellBuy = response[1].data;
          if (response[2].data.length)
            this.USDExchange = response[2].data.filter(element => {
              // return element.SourceType === "USD";
              return element.SourceType !== this.BaseCash;
            });
          // console.log(this.USDExchange);
          this.AdjestUSD();
          this.fillData();
          this.fillPieChart();
          this.fillUSD();
          this.fillAllSellBuy();
          this.weekProfitLoss = Object.assign({}, this.ProfitCalaculate());

          // console.log(this.ProfitCalaculate().toLocaleString());
        });
    },
    cashLoad() {
      return this.$store.dispatch("SelectAll", {
        url: "/cashTypes",
        MutName: "SaveCashTypes",
      });
    },
    jsonCopy(src) {
      return JSON.parse(JSON.stringify(src));
    },
  },
  created() {
    this.cashLoad().then(() => {
      this.ShowTotalCash("Main Cash");
    });
  },
};
</script>
